// Copyright 2025. WebPros International GmbH. All rights reserved.

export const CODE_LENGTH = 6;